module.exports = __webpack_public_path__ + "img/puzzle2-700.be833435.png";